/** @jsx jsx */
import { Box, jsx, Container, Flex, useColorMode, Styled } from 'theme-ui'
import MenuList from './menu-list'

const Topbar = () => {
  return (
    <Box>
      <Container>
        <div
          sx={{
            display: `grid`,
            gridGap: 4,
            gridTemplateColumns: [`1fr`, `1fr`, `1fr`, `2fr 1fr`],
          }}
        >
          <div
            sx={{
              p: { mb: 0 },
              h2: {
                mt: 0,
                mb: 1,
              },
            }}
          ></div>
          <Flex
            sx={{
              textAlign: [`center`, `center`, `center`, `right`],
              flexDirection: `column`,
              justifyContent: `space-between`,
            }}
          >
            <div sx={{ mt: [4, 4, 4, 0] }}>
              <div sx={{ a: { ml: [1, 1, 1, 2], mr: [1, 1, 1, 0] } }}>
                <MenuList />
              </div>
            </div>
          </Flex>
        </div>
      </Container>
    </Box>
  )
}

export default Topbar
